import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import styles from './cursos.module.scss'

import { useAuth } from '../../hooks/useAuth'
import { StorageService } from '@/services/storage'
import { useDownload } from '../@hooks/use-download'
import { Course } from '@/domain/entities/course.entity'
import { imageCoursesStore } from '@/stores/image-courses.store'
import { CursoRepository } from '../admin/repositories/curso.repository'

import { CourseItem } from './course-item'

interface ICursosPage {
  hasCourses: boolean
}

const storageService = new StorageService()

export function CursosPage({ hasCourses }: ICursosPage) {
  const { token } = useAuth()
  const navigate = useNavigate()
  const [cursos, setCursos] = useState<Course[]>([])
  const { download } = useDownload({ storageService })
  const { setImageCourses, imageCourses } = imageCoursesStore()

  const {
    category_id,
    city,
    course,
    neighborhood,
    institution_id,
    institution,
  } = useParams()

  useEffect(() => {
    fetchCursos()
  }, [])

  useEffect(() => {
    const fetchImage = async () => {
      const [{ url }] = await download(cursos[0].Institution.logo)
      setImageCourses({
        id: cursos[0]?.Institution?.id,
        url,
        confirm_cache: cursos[0]?.Institution?.logo,
      })
    }
    if (
      cursos?.length > 0 &&
      imageCourses?.confirm_cache !== cursos[0]?.Institution?.logo
    )
      fetchImage()
  }, [cursos])

  async function fetchCursos() {
    const promise = hasCourses
      ? CursoRepository.GetInstance().listInstitutionCursesByCategory(
          institution_id,
          category_id,
        )
      : await CursoRepository.GetInstance().listCourses(
          token,
          Number(category_id),
          city,
          course,
          neighborhood,
        )
    const data = await promise
    setCursos(data.courses)
  }

  return (
    <div className={styles.mainContainer}>
      <div className={styles.title}>
        {hasCourses && (
          <p>
            {' '}
            Bolsas de estudo encontradas para{' '}
            {institution.replaceAll('-', ' ')}{' '}
          </p>
        )}

        {!hasCourses && <p>Bolsas de estudo encontradas para {course} </p>}
      </div>

      <div className={styles.container}>
        <div className={styles.filtro}>FILTRO</div>
        {cursos.length > 0 && (
          <div className={styles.cursosContainer}>
            {cursos.map((course) => {
              return (
                <CourseItem
                  key={course.id}
                  onClickQuero={() =>
                    navigate(`/register-student/${course.id}/step-1`)
                  }
                  onClickDetalhes={() => navigate(`/curso/${course.id}`)}
                  course={course}
                  logoUrl={imageCourses?.url}
                />
              )
            })}
          </div>
        )}

        {cursos.length === 0 && (
          <div className={styles.title}>
            <p>Nenhum curso encontrado</p>
            <p>Pesquise por outra categoria ou outra instituição</p>
          </div>
        )}
      </div>
    </div>
  )
}
